export default "__VITE_ASSET__27VHvBxJ__"